import styled from 'styled-components';
import { HelpTooltip } from '../../shared/components';
import React, { useState } from 'react';
import { PiTrashLight } from 'react-icons/pi';

const Title = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const HelpIcon = styled.div`
  margin-left: 4px;
`;

const Headers = styled.div``;

const HeaderItem = styled.div`
  display: grid;
  grid-template-columns: 42% 42% auto;
  max-width: 100%;
  gap: 10px;
  margin-bottom: 8px;

  &:nth-child(1) {
    margin-top: -16px;
  }
`;

const PlaceholderIcon = styled.div`
  width: 36px;
  height: 36px;
  margin-top: 8px;
  margin-left: 8px;
`;

const HeaderInput = styled.input`
  color: #fff;
  box-shadow: none;
  background: #000c22;
  border-radius: 30px;
  border: solid 2px #06abc1;
  padding: 16px;
  margin-top: 8px;

  &:hover {
    background: #00153c;
  }
`;

const RemoveHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  margin-left: 8px;
`;

const RemoveHeader = styled.span`
  border: solid 2px #06abc1;
  padding: 4px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  height: fit-content;
`;

export function CustomHttpHeaders({ setValues, values = {} }) {
  const [headerItems, setHeaderItems] = useState(() => {
    // Convert initial object to array with stable IDs
    const items = Object.entries(values).map(([key, value]) => ({
      id: crypto.randomUUID(),
      key,
      value,
    }));
    // Add empty row
    items.push({ id: crypto.randomUUID(), key: '', value: '' });
    return items;
  });

  const updateValues = (newHeaderItems) => {
    // Convert array back to object format for parent
    const newValues = {};
    newHeaderItems.forEach((item) => {
      if (item.key && item.value) {
        newValues[item.key] = item.value;
      }
    });
    setValues(newValues);
  };

  const handleHeaderChange = (id, field, value) => {
    const newHeaderItems = headerItems.map((item) =>
      item.id === id ? { ...item, [field]: value } : item,
    );

    // Check if we need a new empty row
    const lastItem = newHeaderItems[newHeaderItems.length - 1];
    if (lastItem.key || lastItem.value) {
      newHeaderItems.push({ id: crypto.randomUUID(), key: '', value: '' });
    }

    setHeaderItems(newHeaderItems);
    updateValues(newHeaderItems);
  };

  const handleRemoveHeader = (id) => {
    const newHeaderItems = headerItems.filter((item) => item.id !== id);

    // Ensure we always have an empty row
    if (
      newHeaderItems.length === 0 ||
      newHeaderItems[newHeaderItems.length - 1].key ||
      newHeaderItems[newHeaderItems.length - 1].value
    ) {
      newHeaderItems.push({ id: crypto.randomUUID(), key: '', value: '' });
    }

    setHeaderItems(newHeaderItems);
    updateValues(newHeaderItems);
  };

  return (
    <div style={{ marginTop: '-16px' }}>
      <Title>
        <h4>Custom HTTP Headers</h4>
        <HelpIcon>
          <HelpTooltip text='Custom HTTP headers to send with the request. These will override any specific settings set by "Content Type" or "Authorization".' />
        </HelpIcon>
      </Title>
      <Headers>
        {headerItems.map((item) => (
          <HeaderItem key={item.id}>
            <HeaderInput
              value={item.key}
              placeholder="Header Name"
              onChange={(e) => handleHeaderChange(item.id, 'key', e.target.value)}
            />
            <HeaderInput
              value={item.value}
              placeholder="Header Value"
              onChange={(e) => handleHeaderChange(item.id, 'value', e.target.value)}
            />
            {item.key || item.value ? (
              <RemoveHeaderContainer>
                <RemoveHeader onClick={() => handleRemoveHeader(item.id)}>
                  <PiTrashLight
                    size={24}
                    color={'#fff'}
                  />
                </RemoveHeader>
              </RemoveHeaderContainer>
            ) : (
              <PlaceholderIcon />
            )}
          </HeaderItem>
        ))}
      </Headers>
    </div>
  );
}
